import { rgba } from 'polished';

/**
 * Parses a text shadow alias to its CSS value based on the theme.
 *
 * @param theme - The theme object.
 * @param shadow - The text shadow alias to resolve a value for.
 */ function parseTextShadow(theme, shadow) {
    const { size, blur, opacity } = theme.aliases.textShadows[shadow];
    return `0px ${size}px ${blur}px ${rgba('black', opacity)}`;
}

export { parseTextShadow };
//# sourceMappingURL=text-shadow.js.map
